import React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import IconButton from '@mui/material/IconButton';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from '@mui/icons-material/Download';
import BlockIcon from '@mui/icons-material/Block';
import { useExport } from 'context/ExportContext';

export default function ExportSnackbar() {
  const { exports, cancelExport, dismissExport } = useExport();
  if (!exports.length) return null;

  return (
    <Box sx={{
      position: 'fixed',
      bottom: 24,
      right: 24,
      zIndex: 9999,
      display: 'flex',
      flexDirection: 'column',
      gap: 1,
    }}>
      {exports.map(exp => (
        <Paper
          key={exp.id}
          elevation={4}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            px: 2,
            py: 1.5,
            borderRadius: 2,
            minWidth: 280,
            maxWidth: 400,
            borderLeft: '4px solid',
            borderLeftColor:
              exp.status === 'done'      ? '#39a82d' :
              exp.status === 'error'     ? '#d32f2f' :
              exp.status === 'cancelled' ? '#9e9e9e' : '#8ebf63',
          }}
        >
          {exp.status === 'loading' && (
            <CircularProgress size={20} sx={{ color: '#8ebf63', flexShrink: 0 }} />
          )}
          {exp.status === 'done' && (
            <CheckCircleIcon sx={{ color: '#39a82d', fontSize: 22, flexShrink: 0 }} />
          )}
          {exp.status === 'error' && (
            <ErrorIcon sx={{ color: '#d32f2f', fontSize: 22, flexShrink: 0 }} />
          )}
          {exp.status === 'cancelled' && (
            <BlockIcon sx={{ color: '#9e9e9e', fontSize: 22, flexShrink: 0 }} />
          )}
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography variant="body2" fontWeight="bold" noWrap>
              <DownloadIcon sx={{ fontSize: 13, mr: 0.5, verticalAlign: 'middle' }} />
              {exp.label} — {exp.format}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {exp.status === 'loading'   && 'Preparando descarga...'}
              {exp.status === 'done'      && 'Descarga completada ✓'}
              {exp.status === 'cancelled' && 'Descarga cancelada'}
              {exp.status === 'error'     && (exp.detail || 'Error al exportar')}
            </Typography>
          </Box>
          {exp.status === 'loading' && (
            <IconButton size="small" onClick={() => cancelExport(exp.id)} title="Cancelar descarga">
              <CloseIcon fontSize="small" />
            </IconButton>
          )}
          {exp.status !== 'loading' && (
            <IconButton size="small" onClick={() => dismissExport(exp.id)}>
              <CloseIcon fontSize="small" />
            </IconButton>
          )}
        </Paper>
      ))}
    </Box>
  );
}
